import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { ReactComponent as PriorityHigh } from "assets/priority_high.svg";

export default function ExpiringSubscriptionDialog({
  isOpen,
  setIsOpen,
  isTrial,
  closeExpiringSubscriptionDialog,
}: {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  isTrial: boolean;
  closeExpiringSubscriptionDialog: () => void;
}) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5  rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
            )}
          >
            <PriorityHigh className="w-16 h-16 fill-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">
            {isTrial
              ? t("settings.expiringSubscriptionDialog.trialTitle")
              : t("settings.expiringSubscriptionDialog.subscriptionTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {isTrial
              ? t("settings.expiringSubscriptionDialog.trialDescription")
              : t("settings.expiringSubscriptionDialog.subscriptionDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction className="w-full md:flex-1" onClick={closeExpiringSubscriptionDialog}>
            {t("button.ok")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
